import * as effects from 'redux-saga/effects';
import { put } from 'redux-saga/effects';
import { send } from '@giantmachines/redux-websocket';
import { chatActions } from '../../../chat/actions';
import { wsActions } from '../../actions';
import { handleError } from '../../../handleError';

export function* sendMessageRequest({
  payload,
  meta: { resolve },
}) {
  try {
    yield effects.put(wsActions.setSocketsStatus('SEND'));
    yield effects.put(wsActions.setClosedSockets(false));
    yield effects.put(wsActions.startFetching());
    yield put(send(payload, 'WS'));
    if (payload.event === 'visualize') {
      yield effects.put(chatActions.startIsImageLoading());
    }

    resolve();
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(wsActions.stopFetching());
  }
}
